import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Spin from "components/spin/spin";
import "./emailBuilderCanvasLoadingPlaceholder.scss";

interface IEmailBuilderCanvasLoadingPlaceholderProps {
  className?: string;
  style?: React.CSSProperties;
}

export function EmailBuilderCanvasLoadingPlaceholder(
  props: IEmailBuilderCanvasLoadingPlaceholderProps,
) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames("email-builder-canvas-loading", props.className)}
      style={props.style}
      role="status"
      aria-busy={true}
      aria-label={t("Loading email")}
    >
      <div className="email-builder-canvas-loading__card">
        <Spin className="email-builder-canvas-loading__spinner" />
      </div>
    </div>
  );
}
